"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFY_SA_INPUT_EVENT = exports.NOTIFY_SA_CLICK_EVENT = exports.coreNotifyEvents = void 0;
var event_tracking_core_1 = require("@al/event-tracking-core");
Object.defineProperty(exports, "coreNotifyEvents", { enumerable: true, get: function () { return event_tracking_core_1.notifyEvents; } });
exports.NOTIFY_SA_CLICK_EVENT = "saClickEvent";
exports.NOTIFY_SA_INPUT_EVENT = "saInputEvent";
